(function () {
  const CSS = `
    /* Typography */
    h2.font-medium.text-3xl {
      font-size: 32px !important;
      line-height: 1.05 !important;
      letter-spacing: -0.02em !important;
      font-family: 'lust-text' !important;
      font-weight: 300 !important;
    }

    /* Hide only the subtitle "How it works" (NOT every opacity-70 element) */
    p.text-14.opacity-70 {
      display: none !important;
    }

    .font-semibold {
      font-size: 14px !important;
      font-weight: 400 !important;
    }

    .text-14 {
      letter-spacing: 1px !important;
      font-size: 12px !important;
      font-weight: 400 !important;
    }

    .rounded-md {
      border-radius: 0px !important;
    }

    .text-base {
      font-size: 12px !important;
      letter-spacing: 1px !important;
      line-height: 24px !important;
    }

    button {
      border-radius: 0px !important;
    }

    /* SAFARI FIX: stop invisible elements from stealing clicks */
    .sr-only,
    .opacity-0 {
      pointer-events: none !important;
    }
  `;

  const STYLE_ID = 'listify-custom-overrides';

  function injectInto(root) {
    if (!root || !root.appendChild) return;
    if (root.getElementById && root.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    root.appendChild(style);
  }

  function walkAndInject(node) {
    if (!node) return;

    // If node has a shadow root, inject there
    if (node.shadowRoot) injectInto(node.shadowRoot);

    // Walk light DOM children
    if (node.children) {
      for (const child of node.children) walkAndInject(child);
    }
  }

  function run() {
    const host = document.querySelector('#listify-modal-root');
    if (!host) return false;

    // inject into the host shadow root + any nested ones
    if (host.shadowRoot) injectInto(host.shadowRoot);
    walkAndInject(host.shadowRoot);

    return true;
  }

  // Poll briefly because the modal mounts after a click
  const start = Date.now();
  const t = setInterval(() => {
    const ok = run();
    if (ok || Date.now() - start > 12000) clearInterval(t);
  }, 200);

})();